import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=56b2f404&scoped=true&"
import script from "./ModalWindow.vue?vue&type=script&lang=js&"
export * from "./ModalWindow.vue?vue&type=script&lang=js&"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=56b2f404&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2f404",
  null
  
)

export default component.exports